import React, { Component } from 'react'
import { connect } from 'react-redux'

import './massinvoice.scss'

import moment from 'moment'

import Modal from '../../components/Modal'

// Actions
import { massInvoiceOrders } from '../../../actions/invoicing'
import { getPriceList } from '../../../actions/priceModel'

// Utils
import { makeOrderTypeImage, makeOrderInvoiceIcon } from '../../../utils/order'
// import { isTouchDevice } from '../../../utils/detect'
import { hasAccess } from '../../../utils/auth'
import { formatCurrency } from '../../../utils/currency'
import { translation, enumtranslate } from '../../../utils/helpers'

// Elements
import Radio from '../../elements/radio'
import Check from '../../elements/check'
import Icon from '../../elements/icon'
import Inline from '../../elements/inline'
import Divider from '../../elements/divider'
import TableRow from '../../elements/tableRow'
import Grid from '../../elements/grid'

import { MassInvoiceIcons, ModalIcons } from '../../elements/icons'

class MassInvoice extends Component {
  constructor (props) {
    super(props)

    this.state = {
      orders: [],
      invoicedOrders: [],
      selectedOrders: [],
      // allSelected: false,
      selectedAction: 0,
      addon: false,
      limit: 20
    }

    this.isWP = this.isWP.bind(this)
    this.getActionName = this.getActionName.bind(this)
    this.onActionChange = this.onActionChange.bind(this)
    this.onOrderChange = this.onOrderChange.bind(this)
    this.isSelected = this.isSelected.bind(this)
    this.renderActions = this.renderActions.bind(this)
    this.renderCheckbox = this.renderCheckbox.bind(this)
    this.renderOrders = this.renderOrders.bind(this)
    this.executeAction = this.executeAction.bind(this)
    this.renderView = this.renderView.bind(this)
    this.onClose = this.onClose.bind(this)
    this.fixSuccessfulOrders = this.fixSuccessfulOrders.bind(this)
    this.filterSuccessfulSelectedOrders = this.filterSuccessfulSelectedOrders.bind(this)
  }

  componentDidMount () {
    const notInvoicingOrders = this.props.orders.reduce((filtered, orderGroup, groupKey) => {
      const readyForInvoice = orderGroup.orders.filter((o, orderKey) =>
        !this.props.itemsIsInvoicing.includes(o.Id))

      if (readyForInvoice.length !== 0) {
        filtered.push({
          StepId: orderGroup.StepId,
          DictionaryKey: orderGroup.DictionaryKey,
          orders: readyForInvoice
        })
      }

      return filtered
    }, [])

    const notInvoicingInvoicedOrders = this.props.invoicedOrders.reduce((filtered, orderGroup, groupKey) => {
      const notInvoicing = orderGroup.orders.filter((o, orderKey) =>
        !this.props.itemsIsInvoicing.includes(o.Id))

      if (notInvoicing.length !== 0) {
        filtered.push({
          StepId: orderGroup.StepId,
          DictionaryKey: orderGroup.DictionaryKey,
          orders: notInvoicing
        })
      }

      return filtered
    }, [])

    this.setState({
      orders: notInvoicingOrders,
      invoicedOrders: notInvoicingInvoicedOrders
    })
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.orders !== this.state.orders || nextProps.invoicedOrders !== this.state.invoicedOrders) {
      const { orders, invoicedOrders, response } = nextProps
      const { selectedOrders } = this.state
      let invOrders = this.fixSuccessfulOrders(response, invoicedOrders)
      let newOrders = this.fixSuccessfulOrders(response, orders)
      let selOrders = this.filterSuccessfulSelectedOrders(response, selectedOrders)
      this.setState({
        orders: newOrders,
        invoicedOrders: invOrders,
        selectedOrders: selOrders
      })
    }
  }

  fixSuccessfulOrders (response, orders) {
    if (response) {
      const { success } = response
      if (success !== undefined && success !== true && success.length !== 0) {
        // Remove the successful orders
        orders = orders.reduce((newOrders, group) => {
          const filtered = group.orders.filter(o => {
            return !success.find(s => s.Id === o.Id)
          })

          if (filtered.length !== 0) {
            const newGroup = { ...group }
            newGroup.orders = filtered

            return [ ...newOrders, newGroup ]
          }
          return newOrders
        }, [])
      }
    }
    return orders
  }

  filterSuccessfulSelectedOrders (response, orders) {
    if (response) {
      const { success } = response
      if (success !== undefined && success !== true && success.length !== 0) {
        // Remove the successful orders
        orders = orders.filter(o => {
          return !success.find(s => s.Id === o)
        })
      }
    }
    return orders
  }

  isWP () {
    return hasAccess([6], this.props.auth.user.UserType)
  }

  getActionName (id) {
    let dictionaryKey = '13503'
    if (id === 1) {
      dictionaryKey = '13504'
    } else if (id === 2) {
      dictionaryKey = '13505'
    }

    return translation(dictionaryKey)
  }

  onActionChange ({ target: { value, name } }) {
    if (name === 'Addon') {
      return this.setState({
        addon: !this.state.addon
      })
    }

    this.setState({
      selectedAction: parseInt(value, 10),
      selectedOrders: []
      // allSelected: false
    })
  }

  renderActions () {
    const { selectedAction } = this.state

    const renderAddon = () => {
      let addonInputValue = true
      return (
        <Check
          spacing={0}
          id='Addon'
          name='Addon'
          value={addonInputValue}
          onChange={this.onActionChange}
          checked={this.state.addon}
          labelText={translation('2092')} />
      )
    }

    const renderAction = (id, value) => {
      // let img = '/images/svgs/invoice/posted-not-billed.svg'
      let dictionaryKey = 13503
      if (value === 1) {
        // img = '/images/svgs/invoice/billed-not-posted.svg'
        dictionaryKey = 13504
      } else if (value === 2) {
        // img = '/images/svgs/invoice/Payment-ok-VS.svg'
        dictionaryKey = 13505
      }

      let label = (
        <Inline spacing={0}>
          <Icon injectSvg={false} icon={makeOrderInvoiceIcon(value)} aria-label={translation(dictionaryKey)} />
          {this.getActionName(value)}
        </Inline>
      )

      return (
        <Radio
          spacing={1}
          key={value}
          id={id}
          name={id}
          value={value}
          onChange={this.onActionChange}
          checked={selectedAction === value}
          labelText={label} />
      )
    }

    return (
      <div className='massinvoice__actions'>
        {renderAction('OnlySend', 0)}
        {!this.isWP() && selectedAction === 0 && renderAddon()}
        {renderAction('Mark', 1)}
        {renderAction('SendAndMark', 2)}
        {!this.isWP() && selectedAction === 2 && renderAddon()}
        <Divider />
      </div>
    )
  }

  onOrderChange ({target: { value, name }}) {
    // const { selectedAction, orders, invoicedOrders } = this.state
    // const ordersList = selectedAction === 1 ? invoicedOrders : orders

    // if (name === 'All') {
    //   if (this.state.allSelected) {
    //     return this.setState({
    //       selectedOrders: [],
    //       allSelected: false
    //     })
    //   } else {
    //     const ids = ordersList.reduce((ids, group) => [...ids, ...group.orders.map(o => o.Id)], [])

    //     return this.setState({
    //       selectedOrders: ids,
    //       allSelected: true
    //     })
    //   }
    // }

    let selected = [...this.state.selectedOrders]
    value = parseInt(value, 10)
    // let allSelected = this.state.allSelected

    if (this.isSelected(value)) {
      selected = selected.filter(s => s !== value)

      // if (this.state.allSelected) {
      //   allSelected = false
      // }
    } else {
      // If selected limit has been reached, return error msg
      if (selected.length === this.state.limit) {
        window.toastr.error(translation('15176'), translation('216'))
        return
      }

      selected.push(value)

      // const ordersLength = ordersList.reduce((count, group) => count + group.orders.length, 0)
      // if (selected.length === ordersLength) {
      //   allSelected = true
      // }
    }

    this.setState({
      // allSelected,
      selectedOrders: selected
    })
  }

  isSelected (id) {
    return this.state.selectedOrders.includes(id)
  }

  renderCheckbox (label, id, key) {
    return (
      <Check
        key={key}
        spacing={0}
        labelText={label()}
        id={`MassInvoice_${id}`}
        name='MassInvoice'
        value={id}
        onChange={this.onOrderChange}
        checked={this.isSelected(id)} />
    )
  }

  renderOrders (orders) {
    if (!orders || orders.length === 0) {
      return (
        <div className='massinvoice__orders massinvoice__noorders'>
          {translation('14988')}
        </div>
      )
    }

    const renderGroup = (group, key) => {
      if (group.DictionaryKey === 395) return null
      let orders = group.orders
      let result = []
      if (group.DictionaryKey === 2703) {
        let archivedOrders = []
        let date = new Date()
        date.setDate(date.getDate() - (date.getDay() || 7) + 1)
        date.setHours(0)
        date.setMinutes(0)
        date.setMilliseconds(0)
        orders.map((order) => {
          if (archivedOrders.filter((archiveOrder) => archiveOrder.Id === order.Id).length === 0) {
            archivedOrders.push(order)
          }
        })
        let ordersThisWeek = archivedOrders.filter((order) => new Date(order.ArchiveDate) > date)
        orders = archivedOrders.filter((order) => new Date(order.ArchiveDate) <= date)
        if (ordersThisWeek.length > 0) {
          result.push(
            <div key={key}>
              <TableRow header>
                <Inline alignChildren='center' spacing={0}>
                  {this.props.getHeaderIcon(group)}
                  {translation(2702)}
                </Inline>
              </TableRow>
              {ordersThisWeek.map(renderOrder)}
            </div>
          )
          key = key + '_1'
        }
      }
      result.push(
        <div key={key}>
          <TableRow header>
            <Inline alignChildren='center' spacing={0}>
              {this.props.getHeaderIcon(group)}
              {translation(group.DictionaryKey)}
            </Inline>
          </TableRow>
          {orders.map(renderOrder)}
        </div>
      )
      return result
    }

    const renderOrder = (o, key) => {
      const label = () => {
        let key = 0
        const brand = o.BrandName && o.BrandName.Name !== '2000' ? o.BrandName.Name : ''
        let typeHover = translation(enumtranslate('OrderTypes', o.OrderType))
        if (o.HasInvoiceError) {
          const dictionaryKey = this.props.getErrDictionaryKey(o.InvoiceError)
          typeHover += ` - ${translation(dictionaryKey)}`
        }

        return (
          <Grid cols={['min-content', 1, 2.25, 2.75, 1, 1]} align='center'>
            <span className='hint--right' aria-label={typeHover} key={key++}>
              <img style={{ width: 25, height: 25 }} src={!o.HasInvoiceError ? makeOrderTypeImage(o.OrderType) : 'images/svgs/invoice/warning-sign.svg'} />
            </span>
            <span key={key++}>{o.RegNumber}</span>
            <span key={key++}>
              {brand} {o.Model}
            </span>
            <span key={key++}>{o.CustomerName}</span>
            <span className='centered' key={key++}>{moment(o.Delivery).format('DD-MM-YYYY')}</span>
            <span className='price' key={key++}>{formatCurrency(o.TotalPrice)}</span>
          </Grid>
        )
      }

      return (
        <TableRow key={key}>
          {this.renderCheckbox(label, o.Id, key)}
        </TableRow>
      )
    }

    // Not sure if this is supposed to be used at some point
    /* <input
      type='checkbox'
      id={`MassInvoice_All`}
      name='All'
      value={this.state.allSelected}
      onChange={this.onOrderChange}
      checked={this.state.allSelected} />
      <label htmlFor='MassInvoice_All'>{translation('531')}</label> */

    return (
      <div>
        <div className='category-icons'>
          <Grid cols={['67px', 1, 2.25, 2.75, 1, 1]} spacing={1} align='center' justify='center'>
            <span />
            <span aria-label={translation('78')} className='hint--top'><Icon injectSvg={false} icon={MassInvoiceIcons.Reg_No} /></span>
            <span aria-label={translation('145') + ' & ' + translation('146')} className='hint--top'><Icon injectSvg={false} icon={MassInvoiceIcons.Type_Model} /></span>
            <span aria-label={translation('58')} className='hint--top'><Icon injectSvg={false} icon={MassInvoiceIcons.Customer} /></span>
            <span aria-label={translation('193')} className='hint--top'><Icon injectSvg={false} icon={MassInvoiceIcons.Handsover} /></span>
            <span aria-label={translation('641')} className='hint--top'><Icon injectSvg={false} icon={MassInvoiceIcons.Total_price} /></span>
          </Grid>
        </div>
        <div className='listcontainer'>
          <div className='list'>
            {orders.map(renderGroup)}
          </div>
        </div>
      </div>
    )
  }

  executeAction () {
    if (this.props.isLoading) return

    const { selectedAction, selectedOrders, addon, orders, invoicedOrders } = this.state
    const { orderKeys } = this.props.meta
    if (selectedOrders.length !== 0) {
      const realOrders = selectedAction !== 1 ? orders : invoicedOrders

      // Filter out all selected orders
      const actionOrders = realOrders.reduce((ords, group) => {
        const orders = group.orders.filter(o => selectedOrders.includes(o.Id))
        return orders.length !== 0 ? [ ...ords, ...orders ] : ords
      }, [])

      this.props.executeMassInvoice(actionOrders, selectedAction, addon, { orderKeys })
    } else {
      window.toastr.error(translation('14989'), translation('216'))
    }
  }

  renderView () {
    const { selectedAction, orders, invoicedOrders } = this.state

    let listOrders = selectedAction === 1 ? invoicedOrders : orders

    // Response handling
    let responseMsg = ''
    let responseClass = 'massinvoice__success'
    if (this.props.response) {
      const { errors, action } = this.props.response
      if (!errors) {
        switch (action) {
          case 0:
            responseMsg = `${translation('13424')} – ${translation('14990')}`
            break
          case 1:
            responseMsg = `${translation('13424')} – ${translation('14991')}`
            break
          case 2:
            responseMsg = `${translation('13424')} – ${translation('14992')}`
            break
          default:
            break
        }
        // if (success !== true && success.length !== 0) {
        //   console.log('fix successful orders')
        //   // Remove the successful orders
        //   listOrders = listOrders.reduce((newOrders, group) => {
        //     const filtered = group.orders.filter(o => {
        //       return !success.find(s => s.Id === o.Id)
        //     })

        //     if (filtered.length !== 0) {
        //       const newGroup = { ...group }
        //       newGroup.orders = filtered

        //       return [ ...newOrders, newGroup ]
        //     }
        //     return newOrders
        //   }, [])
        // }
      } else {
        if (errors !== true && errors.length !== 0) {
          // Filter out the failing orders
          // listOrders = listOrders.reduce((errOrders, group) => {
          //     const filtered = group.orders.reduce((errorOrders, o) => {
          //         const eo = errors.find(e => e.order.Id === o.Id)
          //         return eo ? [ ...errorOrders, eo.order ] : errorOrders
          //     }, [])

          //     if (filtered.length !== 0) {
          //         const errGroup = { ...group }
          //         errGroup.orders = filtered

          //         return [ ...errOrders, errGroup ]
          //     }
          //     return errOrders
          // }, [])
          responseMsg = `${translation('960')} – ${translation('14993')}`
        } else {
          responseMsg = translation('960')
        }

        responseClass = 'massinvoice__error'
      }
    }

    return (
      <div className='massinvoice__content'>
        {this.renderActions()}
        {responseMsg && <div className={responseClass}>{responseMsg}</div>}
        {this.renderOrders(listOrders)}
      </div>
    )
  }

  onClose () {
    this.setState({
      orders: [],
      invoicedOrders: [],
      selectedOrders: [],
      // allSelected: false,
      selectedAction: 0,
      addon: false
    },
    () => this.props.onClose())
  }

  render () {
    // const header = () => {
    //   return [
    //     <img src={'/images/svgs/listheader/mass-invoiceing-white.svg'} className='header__icon' />,
    //     translation('14994')
    //   ]
    // }

    const renderText = () => {
      if (this.props.isLoading) {
        return (
          <span className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
          </span>
        )
      }
      return this.getActionName(this.state.selectedAction)
    }

    return (
      <div className='massinvoice'>
        <Modal
          header={translation('14994')}
          icon={ModalIcons.Mass_Invoice}
          onClose={this.onClose}
          show={this.props.show}
          bottomBarProps={{
            actionLabelText: renderText(),
            onActionClick: this.executeAction
          }}
        >
          {this.renderView()}
        </Modal>
      </div>
    )
  }
}

MassInvoice.contextTypes = {
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  massInvoiceOrders,
  getPriceList
})(MassInvoice)



// WEBPACK FOOTER //
// ./src/app/shared/modals/MassInvoice/index.js